<template>
  <div
    class="inline-notification-wrap"
    v-if="visibility"
    :dependentComputedProps="{}"
  >
    <div
      class="flex-row justify-content-between align-items-center"
      :class="[
        clientPlatform == 'Web' ? 'container-desktop extended' : 'mx-width',
      ]"
    >
      <div class="inline-content medium fs-12" :dependentComputedProps="{}">
        {{ getNotificationData?.title }}
      </div>
      <div
        class="inline-cta-btns"
        v-if="
          getNotificationData?.actionLabel ||
          getNotificationData?.closable == '1'
        "
      >
        <button
          class="inline-action-cta medium fs-12 ml10"
          v-if="getNotificationData?.actionLabel"
          v-on:click="ctaClickHandle(getNotificationData?.actionLabel)"
        >
          {{ getNotificationData?.actionLabel }}
        </button>
        <button
          class="inline-close-btn hkfi-close fs-20"
          v-if="getNotificationData?.closable == '1'"
          v-on:click="closeHandle()"
        ></button>
      </div>
      <!-- <span class="inline-action-cta fs-11 medium">Track</span>
        <i class="inline-close-btn hkfi-close fs-18"></i> -->
    </div>
  </div>
</template>

<script>
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  EVENT_IMPRESSION_INLINENOTIFICATION,
  EVENT_CLICK_INLINENOTIFICATION,
} from "../helpers/analyticsEvents";
import { clientPlatform } from "../config/apiEndpoints";
export default {
  name: "InlineNotification",
  props: {
    moduleProps: {},
  },
  components: {},
  data() {
    return {
      impressionProcessed: false,
      showInlineNotificationModule: true,
      // content: this.moduleProps.inlineContent,
      // ctaBtn: this.moduleProps.inlineCta,
      // showClose: this.moduleProps.showInlineClose,
      clientPlatform,
    };
  },
  mounted() {
    // console.log("inline mounted", this.moduleProps);
    // this.$store.dispatch(keyMapsAction.GET_INLINE_NOTIFICATION_DATA, true);
  },
  methods: {
    closeHandle() {
      EVENT_CLICK_INLINENOTIFICATION();
      this.showInlineNotificationModule = false;
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_NOTIFICATION_STATUS_DATA,
        false
      );
      let domain = window.location.hostname;
      // console.log("domain", domain);
      if (this.getNotificationData?.frequency == "WEEKLY") {
        Utility.setCookie(
          "Notification_" + this.getNotificationData?.id,
          this.getNotificationData?.frequency,
          7,
          domain
        );
        // console.log("cookie set for weekly");
      } else if (this.getNotificationData?.frequency == "DAILY") {
        Utility.setCookie(
          "Notification_" + this.getNotificationData?.id,
          this.getNotificationData?.frequency,
          1,
          domain
        );
        // console.log("cookie set for daily");
      } else if (this.getNotificationData?.frequency == "YEARLY") {
        Utility.setCookie(
          "Notification_" + this.getNotificationData?.id,
          this.getNotificationData?.frequency,
          365,
          domain
        );
      } else {
        Utility.setCookie(
          "Notification_" + this.getNotificationData?.id || -1,
          1,
          1,
          domain
        );
      }
      this.$store.commit(
        keyMapsMutation.REMOVE_NOTIFICATOIN_STATUS_DATA,
        this.getNotificationData
      );
      this.removeNotificationClass();
      this.$store.commit(keyMapsMutation.UPDATE_NOTIFICATION_STATUS_DATA, {});
      if (this.visibility) {
        this.addHeightClass();
      }
    },
    removeNotificationClass() {
      if (document.body.classList.contains("show-notif-top")) {
        document.body.classList.remove("show-notif-top");
      }
      if (document.body.classList.contains("show-notif-bottom")) {
        // console.log('hi from show')
        document.body.classList.remove("show-notif-bottom");
      }
      if (document.body.classList.contains("show-notif-top-big")) {
        document.body.classList.remove("show-notif-top-big");
      }
      if (document.body.classList.contains("show-notif-bottom-big")) {
        // console.log('hi from show')
        document.body.classList.remove("show-notif-bottom-big");
      }
      if (document.body.classList.contains("cart-show-notif-top")) {
        document.body.classList.remove("cart-show-notif-top");
      }
      if (document.body.classList.contains("cart-show-notif-bottom")) {
        // console.log('hi from cart-show')
        document.body.classList.remove("cart-show-notif-bottom");
      }
      if (document.body.classList.contains("cart-show-notif-top-big")) {
        document.body.classList.remove("cart-show-notif-top-big");
      }
      if (document.body.classList.contains("cart-show-notif-bottom-big")) {
        // console.log('hi from cart-show')
        document.body.classList.remove("cart-show-notif-bottom-big");
      }
    },
    ctaClickHandle(btn) {
      EVENT_CLICK_INLINENOTIFICATION();
      if (this.getNotificationData?.actionUrl.includes("/offers")) {
        const redirectUrl = this.getNotificationData?.actionUrl;
        Utility.redirectToLinkRewrite(redirectUrl);
      } else if (
        this.getNotificationData?.actionUrl.includes("/order-tracking")
      ) {
        const redirectUrl =
          this.getNotificationData?.actionUrl +
          "?transactionId=" +
          LocalStorageFunc.getOrderTransactionId();
        Utility.redirectToLinkRewrite(redirectUrl);
      }
    },
    addHeightClass() {
      if (this.visibility == true) {
        let height =
          document.getElementsByClassName("inline-notification-wrap")[0]
            ?.clientHeight || 0;
        this.removeNotificationClass();
        if (this.getNotificationData?.placement == "top") {
          if (height > 50) {
            if (this.isOnCartPage) {
              document.body.classList.add("cart-show-notif-top-big");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "cart-show-notif-top-big"
              );
            } else {
              document.body.classList.add("show-notif-top-big");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "show-notif-top-big"
              );
            }
          } else {
            if (this.isOnCartPage) {
              document.body.classList.add("cart-show-notif-top");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "cart-show-notif-top"
              );
            } else {
              document.body.classList.add("show-notif-top");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "show-notif-top"
              );
            }
          }
        } else if (this.getNotificationData?.placement == "bottom") {
          if (height > 50) {
            if (this.isOnCartPage) {
              document.body.classList.add("cart-show-notif-bottom-big");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "cart-show-notif-bottom-big"
              );
            } else {
              document.body.classList.add("show-notif-bottom-big");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "show-notif-bottom-big"
              );
            }
          } else {
            if (this.isOnCartPage) {
              document.body.classList.add("cart-show-notif-bottom");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "cart-show-notif-bottom"
              );
            } else {
              document.body.classList.add("show-notif-bottom");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "show-notif-bottom"
              );
            }
          }
        } else if (this.getNotificationData?.placement == "relative") {
          if (height > 50) {
            if (this.isOnCartPage) {
              document.body.classList.add("cart-show-notif-relative-big");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "cart-show-notif-relative-big"
              );
            } else {
              document.body.classList.add("show-notif-relative-big");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "show-notif-relative-big"
              );
            }
          } else {
            if (this.isOnCartPage) {
              document.body.classList.add("cart-show-notif-relative");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "cart-show-notif-relative"
              );
            } else {
              document.body.classList.add("show-notif-relative");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "show-notif-relative"
              );
            }
          }
        } else {
          if (height > 50) {
            if (this.isOnCartPage) {
              document.body.classList.add("cart-show-notif-top-big");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "cart-show-notif-top-big"
              );
            } else {
              document.body.classList.add("show-notif-top-big");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "show-notif-top-big"
              );
            }
          } else {
            if (this.isOnCartPage) {
              document.body.classList.add("cart-show-notif-top");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "cart-show-notif-top"
              );
            } else {
              document.body.classList.add("show-notif-top");
              this.$store.commit(
                keyMapsMutation.UPDATE_NOTIFICATION_POSITION,
                "show-notif-top"
              );
            }
          }
        }
        // console.log("height", height);
      }
    },
    //
  },
  updated() {
    this.addHeightClass();
  },
  computed: {
    getNotificationData() {
      if (Object.keys(this.getNotificationStatusData).length > 0) {
        // console.log("status", this.getNotificationStatusData);

        return this.getNotificationStatusData;
      }
      let data = this.$store.state.Notification.notificationData;
      for (let i = 0; i < data.length; i++) {
        let notificationCookie = Utility.getCookie(
          "Notification_" + data[i]?.id
        );
        if (notificationCookie) {
          continue;
        } else {
          this.showInlineNotificationModule = true;
          // console.log("returned", data[i]);
          return data[i];
        }
      }
      this.showInlineNotificationModule = false;
      return;
    },
    getNotificationStatusData() {
      let notificationStatusData = {};
      let notificationStatusDataAll =
        this.$store.state.Notification.notificationStatusData;
      if (notificationStatusDataAll.length > 0) {
        //todo: - check priority
        notificationStatusDataAll.sort((a, b) => {
          if (a.id < b.id) {
            return -1;
          }
          return 1;
        });
        notificationStatusData = notificationStatusDataAll[0];
      }
      if (Object.keys(notificationStatusData).length > 0) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_NOTIFICATION_STATUS_DATA,
          true
        );
      }
      return notificationStatusData;
    },
    showNotificationStatusData() {
      return this.$store.state.Notification.showNotificationStatusData;
    },
    visibility() {
      if (
        (this.getNotificationStatusData &&
          this.showNotificationStatusData &&
          !this.$store.state.Auth.showProfileDrawerModal) ||
        (this.getNotificationData &&
          this.showInlineNotificationModule &&
          !this.$store.state.Auth.showProfileDrawerModal)
      ) {
        if (!this.impressionProcessed) {
          this.impressionProcessed = true;
          EVENT_IMPRESSION_INLINENOTIFICATION({
            subCategory: this.getNotificationStatusData,
          });
        }
        if (
          this.getNotificationStatusData.page == undefined ||
          this.getNotificationStatusData?.page == ""
        ) {
          this.$store.commit(
            keyMapsMutation.UPDATE_NOTIFICATION_VISIBILITY_STATUS_DATA,
            true
          );
          return true;
        }
        if (
          this.getNotificationStatusData?.page == "home" &&
          this.isOnHomePage
        ) {
          this.$store.commit(
            keyMapsMutation.UPDATE_NOTIFICATION_VISIBILITY_STATUS_DATA,
            true
          );
          return true;
        }
        if (
          this.getNotificationStatusData?.page == "cart" &&
          this.isOnCartPage
        ) {
          this.$store.commit(
            keyMapsMutation.UPDATE_NOTIFICATION_VISIBILITY_STATUS_DATA,
            true
          );
          return true;
        }
      }
      this.$store.commit(
        keyMapsMutation.UPDATE_NOTIFICATION_VISIBILITY_STATUS_DATA,
        false
      );
      this.removeNotificationClass();
      return false;
    },
    isOnCartPage() {
      return Utility.isCurrentlyAtUrl("/cart");
    },
    isOnHomePage() {
      return Utility.isCurrentlyAtUrl("/store");
    },
  },
};
</script>

<style></style>
